import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/Protected";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.perms?.length ? "/admin" : "/portal", { replace: true, state: { user: data } });
      })
      .catch((e) => {
        toast.error(errMsg(e));
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return <Spinner label="Menghubungkan akun Google…" />;
}
